/* This is generated code, don't alter */
var IfcOutletTypeEnum;
(function (IfcOutletTypeEnum) {
    IfcOutletTypeEnum[IfcOutletTypeEnum["AUDIOVISUALOUTLET"] = 0] = "AUDIOVISUALOUTLET";
    IfcOutletTypeEnum[IfcOutletTypeEnum["COMMUNICATIONSOUTLET"] = 1] = "COMMUNICATIONSOUTLET";
    IfcOutletTypeEnum[IfcOutletTypeEnum["POWEROUTLET"] = 2] = "POWEROUTLET";
    IfcOutletTypeEnum[IfcOutletTypeEnum["DATAOUTLET"] = 3] = "DATAOUTLET";
    IfcOutletTypeEnum[IfcOutletTypeEnum["TELEPHONEOUTLET"] = 4] = "TELEPHONEOUTLET";
    IfcOutletTypeEnum[IfcOutletTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcOutletTypeEnum[IfcOutletTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcOutletTypeEnum || (IfcOutletTypeEnum = {}));
const IfcOutletTypeEnumCount = 7;
export { IfcOutletTypeEnum, IfcOutletTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcOutletTypeEnum = new Int32Array([147]);
let prefixSumAddressIfcOutletTypeEnum = new Uint32Array([0, 22, 35, 52, 65, 84, 96, 108]);
let slotMapIfcOutletTypeEnum = new Int32Array([1, 2, 4, 5, 0, 3, 6]);
let encodedDataIfcOutletTypeEnum = (new TextEncoder()).encode(".COMMUNICATIONSOUTLET..POWEROUTLET..TELEPHONEOUTLET..USERDEFINED..AUDIOVISUALOUTLET..DATAOUTLET..NOTDEFINED.");
let IfcOutletTypeEnumSearch = new MinimalPerfectHash(gMapIfcOutletTypeEnum, prefixSumAddressIfcOutletTypeEnum, slotMapIfcOutletTypeEnum, encodedDataIfcOutletTypeEnum);
export { IfcOutletTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcOutletTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcOutletTypeEnumSearch, input, cursor, endCursor);
}
